import {createApi} from '@reduxjs/toolkit/query/react'
// import api from 'services/api'
import axios from 'axios'
import BASE_URL from './baseUrl'
// import storage from 'services/storage'

export const transformResponseFromData = (response) => {
    // console.log('api response', response)
    return response
}
export const transformResponseFromMessage = (response) => response.message

// changed to fix "Unsafe usage of optional chaining" error
export const provideTags = (tagName, data, tagField) => {
    if (!data) {
        return [{type: tagName, id: 'LIST'}]
    }

    const items = data.data || []

    return [
        ...items.map((item) => ({
            type: tagName,
            id: item[tagField || '_id'],
        })),
        {type: tagName, id: 'LIST'},
    ]
}
export const provideTag = (tagName, data, tagField) => {
    return data
        ? [{type: tagName, id: data[tagField || '_id']}]
        : [{type: tagName, id: 'LIST'}]
}

export const sendAxiosRequest = (baseUrl, url, method, body, headers) =>
    axios({
        url: `${baseUrl || BASE_URL}/${url}`,
        method,
        data: body,
        withCredentials: true,
        ...(headers && {headers: headers({})}),
    })

const axiosBaseQuery =
    ({baseUrl, headers} = {baseUrl: '', headers: ''}) =>
    async ({url, method, body}) => {
        // console.log('axios basic query', `${baseUrl}/${url}`, method, headers, {
        //     body,
        // })

        try {
            const result = await sendAxiosRequest(
                baseUrl,
                url,
                method,
                body,
                headers
            )

            console.log('axios result', result)

            return {data: result.data}
        } catch (axiosError) {
            // console.log('axios error', axiosError)
            const responseError = {
                // data: err.response?.data,
                error: {
                    status: axiosError.response?.status,
                    data: axiosError.response?.data,
                },
            }

            // handle refresh
            if (
                axiosError.response?.status === 401 &&
                url !== 'auth/refreshToken' &&
                url !== 'auth/login'
            ) {
                try {
                    console.log('requesting refresh')
                    const refreshResult = await sendAxiosRequest(
                        baseUrl,
                        'auth/refreshToken',
                        'GET',
                        body,
                        headers
                    )
                    console.log('refresh result', refreshResult)

                    const result = await sendAxiosRequest(
                        baseUrl,
                        url,
                        method,
                        body,
                        headers
                    )
                    return {data: result.data}
                } catch (refreshError) {
                    console.log(
                        'axios error - refresh error',
                        refreshError,
                        responseError
                    )
                    return responseError
                }
            }

            console.log('axios error', responseError)
            return responseError
        }
    }

const getHeaders = () => {
    return {
        Accept: 'application/json',
    }
}

const baseApi = createApi({
    baseQuery: axiosBaseQuery({
        baseUrl: BASE_URL,
        headers: () => getHeaders(),
    }),
    reducerPath: 'api',
    tagTypes: [
        'CurrentUser',
        'Account',
        'User',
        'Invite',
        'Dance',
        'Guide',
        'Artist',
        'DanceCollection',
        'Session',
        'Country',
        'City',
        'Shape',
        'Type',
        'Message',
        'Payment',
        'Publication',
        'Banner',
        'Newspaper',
    ],
    endpoints: () => ({}),
})

export const uploadFileWithIndication = (
    fileType,
    formData,
    progressUpdate
) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${BASE_URL}/upload/` + fileType, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    const percentUploaded = parseInt(
                        Math.round(
                            (progressEvent.loaded / progressEvent.total) * 100
                        ),
                        10
                    )
                    console.log('uploading', percentUploaded)
                    progressUpdate && progressUpdate(percentUploaded)
                },
            })
            .then((response) => {
                // response.text().then(res => {
                console.log('upload file res', response)
                resolve(response)
                // })
            })
            .catch((error) => {
                console.log('upload file error', error)
                reject(error)
            })
    })
}

export default baseApi
